import Vue from 'vue/dist/vue.esm'
import ReimbursementRequests from 'components/storefront/reimbursement-requests.vue'

export default function buildReimbursementRequests(element) {
  new Vue({
    el: element,
    components: {
      ReimbursementRequests
    }
  })
}
